@if (!connected) {
  <div class="offline-notice">
    <p translate>i18n.error.offlineNotice</p>
  </div>
}
